import { Injectable } from '@angular/core';
import { Http, Headers, RequestOptions, Response, URLSearchParams } from '@angular/http';
import { Observable } from 'rxjs/Observable';

import { RequestService } from '../../../core/services/request.service';
import { ConfigService } from '../../../core/services/config.service';

@Injectable()
export class DomainsService {

  constructor(
    private requestService: RequestService,
    private configService: ConfigService
  ) { }

    getFields(): Array<any> {
        let fields = [
            {
                key: 'name',
                label: 'Name',
                type: 'textbox',
                required: true
            }, {
                key: 'hostName',
                label: 'Host Name (URL)',
                type: 'textbox'
            }, {
                key: 'platformName',
                label: 'Platform Name',
                type: 'textbox',
                required: true
            }, {
                key: 'buyerId',
                label: 'Buyer Id',
                type: 'textbox'
            }
        ];

        return fields;
    }

    getEditFields(): Array<any> {
        let fields = [
            {
                key: 'id',
                label: 'Domain',
                type: 'hidden',
                required: true
            }, {
                key: 'hostName',
                label: 'Host Name (URL)',
                type: 'textbox'
            }, {
                key: 'platformName',
                label: 'Platform Name',
                type: 'textbox',
                required: true
            }, {
                key: 'buyerId',
                label: 'Buyer Id',
                type: 'textbox'
            }
        ];

        return fields;
    }

    getDomainNameFields(): Array<any> {
        let fields = [
            {
                key: 'name',
                label: 'Name',
                type: 'textbox',
                required: true
            },
            {
               key: 'isDefault',
               label: 'Default',
               type: 'radio',
               required: true,
               options: [
                   {key: true,  value: 'Yes'},
                   {key: false,  value: 'No'}
               ],
               default: true
           }
        ];

        return fields;
    }

    getDomain(id: string): Observable<any> {
        let url = this.configService.get('server').url + this.configService.get('endpoints').organization.domain.details.api;
        return this.requestService.get(url);
    }

    makeDomainNameDefault(domainNameId: any): Observable<any> {
        let url = this.configService.get('server').url
            + this.configService.get('endpoints').organization.domain.makeDefault.api + '/' + domainNameId;
        return this.requestService.post(url, {});
    }

}



// WEBPACK FOOTER //
// ./src/app/organization/components/domains/domains.service.ts